import React, { useState, useEffect, useCallback } from 'react';
import './Sidebar.css';

const MIN_WIDTH = 200;
const MAX_WIDTH = 600;
const DEFAULT_WIDTH = 250;
const STORAGE_KEY = 'sutra-sidebar-width';

function Sidebar({ view, children, isOpen, onClose }) {
  const [width, setWidth] = useState(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      return stored ? parseInt(stored, 10) : DEFAULT_WIDTH;
    } catch {
      return DEFAULT_WIDTH;
    }
  });

  const [isResizing, setIsResizing] = useState(false);

  // Persist width to localStorage
  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, width.toString());
    } catch (error) {
      console.error('Failed to save sidebar width:', error);
    }
  }, [width]);

  const startResize = useCallback((e) => {
    setIsResizing(true);
    e.preventDefault();
  }, []);

  const stopResize = useCallback(() => {
    setIsResizing(false);
  }, []);

  const resize = useCallback((e) => {
    if (!isResizing) return;

    const newWidth = e.clientX - 50; // Account for toolbar width
    if (newWidth >= MIN_WIDTH && newWidth <= MAX_WIDTH) {
      setWidth(newWidth);
    }
  }, [isResizing]);

  useEffect(() => {
    if (isResizing) {
      document.addEventListener('mousemove', resize);
      document.addEventListener('mouseup', stopResize);
      document.body.style.cursor = 'col-resize';
      document.body.style.userSelect = 'none';

      return () => {
        document.removeEventListener('mousemove', resize);
        document.removeEventListener('mouseup', stopResize);
        document.body.style.cursor = '';
        document.body.style.userSelect = '';
      };
    }
  }, [isResizing, resize, stopResize]);

  return (
    <>
      {/* Mobile overlay */}
      {isOpen && (
        <div className="sidebar-overlay" onClick={onClose} />
      )}

      <div
        className={`sidebar ${isOpen ? 'sidebar-open' : ''}`}
        style={{ width: `${width}px` }}
      >
        <div className="sidebar-content custom-scrollbar">
          {children}
        </div>

        <div
          className="sidebar-resize-handle"
          onMouseDown={startResize}
          aria-label="Resize sidebar"
        />
      </div>
    </>
  );
}

export default Sidebar;
